import { CZUserNotificationData, NotificationData } from "@/types/notification";
import { NotificationsState } from "@/types/store/clientzone";

export const state: NotificationsState = {
  czUserNotifications: [] as Array<CZUserNotificationData>,
  notifications: [] as Array<NotificationData>,
  uncheckedNotificationsLength: 0
}
